import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Sanitizes the input HTML using Angular's built-in sanitizer
 * (whitelist: safe subset of HTML, no `<script>`, event handlers,
 * `javascript:` URLs, etc.).
 *
 * Does NOT use `bypassSecurityTrustHtml`. If you need to render explicitly
 * trusted HTML (e.g. a built-in template), do it deliberately in the component,
 * not globally through this pipe.
 */
@Pipe({
  name: "safeHtml",
  standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(value: unknown): SafeHtml {
    if (value === null || value === undefined) {
      return '';
    }

    const stringValue = typeof value === 'string' ? value : String(value);
    return this.sanitizer.sanitize(SecurityContext.HTML, stringValue) ?? '';
  }
}
